const MOBILE_QUERY = "(max-width: 600px)";

export function isMobileViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

/** Prefer `data-mobile-src` at the 600px gate; otherwise `data-src`. */
export function resolveDataSrc(el: HTMLElement): string | undefined {
  const mobile = el.dataset.mobileSrc;
  if (mobile && isMobileViewport()) return mobile;
  return el.dataset.src;
}
